import state from "./profileState";
import mutations from "./profileMutations";
import getters from "./profileGetters";
import actions from "./profileActions";
import registrationActions from "./registrationActions";

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions: {
    ...actions,
    ...registrationActions
  }
};
